import React, { useEffect, useState } from 'react';
import './relayOn.css';
import { Button, Checkbox, message } from 'antd';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { getScheduleReportByJobIdQuery } from '@src/util/query/scheduleReport.query';
import { getReportTemplateById } from "@src/util/query/reportTemplate.query";
import { dutyReportToTemplateMapping } from '@src/util/mobileDutyReportToTemplateMapping/mobileDutyReportToTemplateMapping';
import { wrapReportDetailForLegacyLookup } from '@src/util/reportFieldAnswers/reportFieldAnswers';
import Spinner from "@src/components/spinner";
import { liveStatusEndPoint, baseURL } from '@src/config/apollo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';


const RelayOnVPI = (job=null) => {

    const [report, setReport] = useState(null);


    const [processingPdf, setPdfProcessing] = useState(false);

    const param = useParams();




    const {data: reportData, loading: reportDataLoading, refetch: reportDataRefetch} = useQuery(getScheduleReportByJobIdQuery,{
        variables:{
            jobId: (param?.jobId || job?.jobId)
        },
        // skip: (!param?.jobId || !job?.jobId),
        fetchPolicy:'network-only'
    });

    // this layout reads reportDetail by hardcoded legacy label-slug (e.g. report?.sitename) —
    // fetch the template so wrapReportDetailForLegacyLookup can resolve those against new
    // submissions, which are keyed by instanceId instead
    const {data: templateData} = useQuery(getReportTemplateById,{
        variables:{
            templateId: dutyReportToTemplateMapping['relayOnVPI']?.templateId
        },
        fetchPolicy:'network-only'
    });


    const downloadPdfFromUrl = async () => {
        setPdfProcessing(true);
        const url = baseURL+'/relyOnVPI/'+(param?.jobId || job?.jobId);  // Replace this with the link you want to convert
      
        const res = await fetch(liveStatusEndPoint+'/mobilereportpdfgenerator', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ url }), // Pass the URL in the request body
        });
      
        const blob = await res.blob();
        const link = document.createElement('a');
        const urlObject = URL.createObjectURL(blob);
        link.href = urlObject;
        link.download = 'report.pdf';
        link.click();
        URL.revokeObjectURL(urlObject);
        setPdfProcessing(false);
        message.success("Report downloaded successfully");
    };

    useEffect(()=>{
        if(reportData?.getScheduleReportByJobId?.response){

            const templateFields = templateData?.getReportTemplateById?.response?.template?.reportFields?.flatMap((s)=>s?.fields||[]) || [];
            setReport(wrapReportDetailForLegacyLookup(reportData?.getScheduleReportByJobId?.response?.reportDetail, templateFields));

        }else{
            setReport(null)
        }
    },[reportData?.getScheduleReportByJobId?.response, templateData]);



   


  return (
    reportDataLoading?
        <div className='row-flex' style={{justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <Spinner/>
        </div>
        :
    <div>
            
            
        <div id="pdfexportBtn" style={{display:'flex', justifyContent:'right', padding:'20px',
            // position: 'sticky',
            // top: '50px',
            // background: 'white',
        }}>
                <Button disabled={processingPdf} style={{fontSize:'14px'}} onClick={downloadPdfFromUrl}>
                    {processingPdf? 
                        <Spinner/>:
                        <>
                            Download Report &nbsp;<FontAwesomeIcon icon={faDownload} />
                        </>
                    }
                </Button>
        </div>

        <div style={{ 
        fontFamily: 'Arial, sans-serif', 
        fontSize: '12px', 
        maxWidth: '210mm', 
        margin: '0 auto', 
        padding: '20px',
        backgroundColor: 'white'
        }}
        id="pdfContent" 
        // style={{width: "297mm", pageBreakInside: "avoid", margin: '0 auto', maxHeight: "297mm"}}
        >
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '20px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>

            <div style={{width:'150px', height:'100px'}}>
                <img src={'https://wfcrevampdoc.s3.us-east-1.amazonaws.com/customer/67a0cc8782ceb2b53bd36d1c/Customer-67a0cc8782ceb2b53bd36d1c-1754392079460-RELYON_PRIMARY_Group.svg'} />
            </div>
            <div>
                <div style={{
                    fontSize: '22px',
                    fontWeight: 'bold',
                    margin: '0 0 5px 0',
                    textAlign: 'right',
                    borderBottom: '1px solid black'
                }}>
                    Vacant Property Inspection
                </div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    margin: '0'
                }}>
                    <div style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        borderBottom: '1px solid black'
                    }}>
                        Report Form
                    </div>
                </div>
            </div>


        </div>

        {/* Security Personnel Section */}
        <div className='mb32'>
            <div className='relayOnGridSectionHead'>
            Details of Security Personnel Conducting Inspection:
            </div>
            
            <table className='relayOnGrid' border={1}>
                <tr>
                    <th >Date of Attendance</th>
                    <td>{report?.dateofattendance}</td>
                </tr>
                <tr>
                    <th >Time of Attendance</th>
                    <td> 
                        {/* arival */}
                        <b>Arrival : </b>
                        <span>{report?.clockin}</span>
                        &emsp;&emsp;
                        {/* departure */}
                        <b>Departure : </b>
                        <span>{report?.clockout}</span>

                    </td>
                </tr>
                <tr>
                    <th >Full Name</th>
                    <td>

                        <span>{report?.fullname}</span> &emsp;&emsp;
                        <b>Last 4-Digits of SIA Licence:</b>
                        <span>{report?.last4digitalofsia}</span>

                    </td>
                </tr>
                <tr>
                    <th >Inital to Sign</th>
                    <td>
                        <span>{report?.fullname}</span> &emsp;&emsp;
                        & Select to Confirm VPI Complete in Full: <Checkbox checked/>
                    </td>
                </tr>
            </table>

        </div>

        {/* Vacant Property Details Section */}
        <div className='mb32'>
            <div className='relayOnGridSectionHead'>
            Vacant Property Details:
            </div>
            
            <table className='relayOnGrid' border={1}>
                <tr>
                    <th>Site Name</th>
                    <td>{report?.sitename}</td>
                </tr>
                
                <tr>
                    <th>Site ID</th>
                    <td>
                        <b>RGM Number: </b> &nbsp;
                        <span>{report?.siteid}</span>
                    </td>
                </tr>
                
                <tr>
                    <th>Site Address</th>
                    <td>{report?.siteaddress}</td>
                </tr>

                <tr>
                    <th>Site Post Code</th>
                    <td>{report?.sitepostcode}</td>
                </tr>

                <tr>
                    <th>Other Information</th>
                    <td>{report?.otherinformation}</td>
                </tr>

                <tr>
                    <th>Is this the first VPI?</th>
                    <td>{report?.isthisthefirstvpi}</td>
                </tr>

                <tr>
                    <th>Are there changes from the previous visit?</th>
                    <td>

                        <span>{report?.aretherechangesfromthepreviousvisit}</span> &emsp; &emsp;


                        <b>
                            Details:
                        </b> &emsp;
                        <span>{report?.aretherechangesfromthepreviousvisitdetail}</span>

                    </td>
                </tr>
                

            </table>

        </div>

        {/* Meter Readings Section */}
        <div className='mb32'>

            <div className='relayOnGridSectionHead'>
            Meter Readings:
            </div>

            <table className='relayOnGrid' border={1}>
                <tr>
                    <th>Electricity Meter Reading Taken</th>
                    <td>
                        <span>{report?.electricitymeterreadingtaken}</span> &emsp;&emsp;
                        <b>R1:</b> <span>{report?.electricitymeterreading1}</span> &emsp;&emsp;
                        <b>R2:</b> <span>{report?.electricitymeterreading2}</span> &emsp;&emsp;
                        <b>Total:</b> <span>{report?.electricitymetertotalreading}</span> &emsp;&emsp;

                    </td>
                </tr>

                <tr>
                    <th>Gas Meter Reading Taken</th>
                    <td>
                        <span>{report?.gasmeterreadingtaken}</span> &emsp;&emsp;
                        <b>R1:</b> <span>{report?.gasmeterreading1}</span> &emsp;&emsp;
                        <b>R2:</b> <span>{report?.gasmeterreading2}</span> &emsp;&emsp;
                        <b>Total:</b> <span>{report?.gasmetertotalreading}</span> &emsp;&emsp;

                    </td>
                </tr>

                <tr>
                    <th>Water Meter Reading Taken</th>
                    <td>
                        <span>{report?.watermeterreadingtaken}</span> &emsp;&emsp;
                        <b>R1:</b> <span>{report?.watermeterreading1}</span> &emsp;&emsp;
                        <b>R2:</b> <span>{report?.watermeterreading2}</span> &emsp;&emsp;
                        <b>Total:</b> <span>{report?.watermetertotalreading}</span> &emsp;&emsp;

                    </td>
                </tr>

            </table>

        </div>

        {/* External Inspection Section */}
        <div className='mb32'>
            <div className='relayOnGridSectionHead' style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <span>External Inspection</span>

            {/* <small style={{fontSize:'10px'}}>Photos Taken?</small> */}

            </div>

            <table className='relayOnGrid' border={1}>
                <tr>
                    <th>Is there any evidence of fly-tipping/rubbish dumping?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['isthereanyevidenceoffly-tipping/rubbishdumping?']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.evidencedetail}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                        &emsp;&emsp;

                    </td>
                </tr>

                <tr>
                    <th>Excessive foliage growth compromising the property?</th>
                    <td>
                        
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['excessivefoliagegrowthcompromisingtheproperty?']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.['excessivefoliagegrowthdetal?']}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                        
                    </td>
                </tr>

                <tr>
                    <th>Any signs of graffiti?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['anysignsofgraffiti?']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.signsofgraffitidetails}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Any signs of vandalism, intrusion, or wilful damage to the property?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['anysignsofvandalism,intrusion,orwilfuldamagetotheproperty?']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>{report?.['vandalism,intrusion,orwilfuldamagedetails?']}</span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Any signs of neglect, property run-down, in need of repair?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['signsofneglect,propertyrundown,inneedofrepairdetails?']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'></span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Is there any evidence of vermin (rats or pigeons etc)?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['istheranyevidenceofvermin(ratsorpigeonsetc)?']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>{report?.['istheranyevidenceofvermin(ratsorpigeonsetc)detail?']}</span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Any post/parcels/leaflets etc found outside?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['anypost/parcels/leafletsetcfoundoutside?']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["anypost/parcels/leafletsetcfoundoutsidedetails?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Any other observations of note:</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['anyotherobservationsofnote']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.['anyotherobservationsofnotedetail?']}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>


            </table>

        </div>


        {/* Internal Inspection Section */}
        <div className='mb32'>
            <div className='relayOnGridSectionHead' style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <span>Internal Inspection</span>

            {/* <small style={{fontSize:'10px'}}>Photos Taken?</small> */}

            </div>

            <table className='relayOnGrid' border={1}>
                <tr>
                    <th>Was the property fully secure upon arrival?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['wasthepropertyfullysecureuponarrival?']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["wasthepropertyfullysecureuponarrivaldetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                        &emsp;&emsp;

                    </td>
                </tr>

                <tr>
                    <th>Any persons found on site?</th>
                    <td>
                        
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["anypersonsfoundonsite?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["anypersonsfoundonsitedetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                        
                    </td>
                </tr>

                <tr>
                    <th>Are the door locks in working order?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["arethedoorlocksinworkingorder?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["arethedoorlocksinworkingorder(anydetail)?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Was the Intruder Alarm set upon arrival?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["wastheintruderalarmsetuponarrival?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["wastheintruderalarmsetuponarrivaldetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Is the Intruder Alarm in working order?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["istheintruderalarmimworkingorder?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["istheintruderalarmimworkingorderdetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Is the Fire Alarm in working order?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["isthefirealarmimworkingorder?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["isthefirealarmimworkingorderdetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Is the lighting functional/sufficient?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["isthelightingfunctional/sufficient?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["isthelightingfunctional/sufficientdetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Has the post been brought in/moved from externally visible places?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["hasthepostbeenbroughtin/movedfromexternallyvisibleplaces?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["hasthepostbeenbroughtin/movedfromexternallyvisibleplacesdetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>Is the ceiling damaged/discoloured?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["istheceilingdamaged/discoloured?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["istheceilingdamaged/discoloureddetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Are the floors damaged/other issue?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["arethefloorsdamaged/otherissue?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["arethefloorsdamaged/otherissuedetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Are there any water leaks?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["aretheranywaterleaks?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.["aretheranywaterleaksdetail?"]}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Any signs of neglect, property run-down, in need of repair?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.["anysignsofneglect,propertyrun-down,inneedofrepair?"]}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {
                                        report?.["anysignsofneglect,propertyrun-down,inneedofrepairdetail?"]
                                    }
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Is there any evidence of vermin (rats or pigeons etc)?</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>
                                    {report?.['istheranyevidenceofvermin(ratsorpigeonsetc)?']}
                                </span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {
                                        report?.['istheranyevidenceofvermin(ratsorpigeonsetc)detail?']
                                    }
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Any other observations of note:</th>
                    <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div style={{width:'90%'}}>
                                <span>{report?.['anyotherobservationsofnote']}</span> &emsp;&emsp;
                                <b>Details:</b>  &nbsp;
                                <span className='relayOnGridDetailBg'>
                                    {report?.['anyotherobservationsofnotedetail']}
                                </span>
                            </div>
                            {/* <div>
                                <Checkbox/>
                            </div> */}
                        </div>
                    </td>
                </tr>


            </table>

        </div>


            

        <div className='mb32'>

            <div className='relayOnGridSectionHead' style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>Pictures</span>
            </div>

            <table style={{width:'100%'}} className='relayOnGrid' border={1}>
                                

                {!reportDataLoading ?
                    reportData?.getScheduleReportByJobId?.response?.filesURL && Object.values(reportData?.getScheduleReportByJobId?.response?.filesURL)?.map((file)=>(

                        <tr >
                            <td>
                                <div style={{ width:'500px', height:'600px',  cursor:'pointer', margin: 'auto', padding:'10px', overflow:'hidden' }}
                                    onClick={()=>{
                                        window.open(file, "_blank");
                                    }}
                                >
                                    {/* Placeholder for image loading */}
                                    <img
                                        src={file}
                                        alt={"Image placeholder"}
                                        placeholder={<Spinner />}
                                        style={{ maxWidth: "100%", height: "auto" }} // Ensures responsiveness
                                    />
                                </div>
                            </td>
                        </tr>

                    ))
                    :
                    null
                }


            </table>
            
        </div>


        {/* Office Only Section */}
        <div style={{ marginBottom: '20px', border: '2px solid #000', padding: '15px' }}>
            <div className='relayOnGridSectionHead' style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '15px', textAlign: 'center' }}>
                TO BE COMPLETED BY THE OFFICE ONLY:
            </div>
            
            <div style={{ marginBottom: '10px' }}>
            <label style={{ fontWeight: 'bold' }}>Work Order Numbers:</label>
            <input 
                type="text" 
                style={{ width: '100%', border: '1px solid #000', padding: '2px', marginTop: '2px' }}
            />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ fontWeight: 'bold' }}>Accounts Updated?</label>
                <label style={{ marginLeft: '10px' }}>
                Yes
                <input 
                    type="radio" 
                    name="accountsUpdated" 
                    style={{ marginLeft: '3px', marginRight: '3px' }}
                />
                
                </label>
                <label style={{ marginLeft: '10px' }}>
                No
                <input 
                    type="radio" 
                    name="accountsUpdated" 
                    style={{ marginLeft: '3px', marginRight: '3px' }}
                />
                
                </label>
            </div>
            <div>
                <label style={{ fontWeight: 'bold' }}>Date:</label>
                <input 
                type="text" 
                style={{ width: '120px', border: '1px solid #000', padding: '2px', marginLeft: '5px' }}
                />
            </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ fontWeight: 'bold' }}>Saved to RGM</label>
                <input 
                type="checkbox" 
                style={{ marginLeft: '5px', transform: 'scale(1.2)' }}
                />
            </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px', flexWrap: 'wrap' }}>
            <div>
                <label style={{ fontWeight: 'bold' }}>Invoice Number:</label>
                <input 
                type="text" 
                style={{ width: '150px', border: '1px solid #000', padding: '2px', marginLeft: '5px' }}
                />
            </div>
            <div>
                <label style={{ fontWeight: 'bold' }}>Date Due:</label>
                <input 
                type="text" 
                style={{ width: '120px', border: '1px solid #000', padding: '2px', marginLeft: '5px' }}
                />
            </div>
            </div>
        </div>


        {/* Footer */}
        <div style={{ 
            marginTop: '30px', 
            fontSize: '10px', 
            color: '#666', 
            borderTop: '1px solid #ccc', 
            paddingTop: '10px',
            textAlign: 'center'
        }}>
            Document Ref: TBC – Issue Number 001 – Date of Issue – 15/05/2023
        </div>



        </div>

    </div>
  );
};

export default RelayOnVPI;